const getConfig = () => {
	return `query GetConfigs {
    getConfigs{
      year
    }
  }`;
}

export default getConfig;
